import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import notify from "devextreme/ui/notify";
import {NewsService} from "../../services/news.service";
@Component({
  selector: 'app-frm-solicitud',
  templateUrl: './frm-solicitud.component.html',
  styleUrls: ['./frm-solicitud.component.css']
})
export class FrmSolicitudComponent implements OnInit {

  documentos:any=[];
  domain:string;
  data:any={
    tipo:'SOL',
    nombre:'',
    departamento:'',
    ci:'',
    exp:'',
    email:'',
    telefono:'',
    reserva_identidad:'',
    servidores:'',
    entidad:'',
    descripcion:'',
    pruebas:'',
    denuncias:'',
    code:'',
    motivo:'',
    razon_social:'',
    testimonio:'',
    representante:'',

  };
  vare:boolean=true;
  departamentos:any=[];
  value:any;
  namePattern: any = /^[a-zA-Z ÁÉÍÓÚáéíóúñÑ]{3,100}$/;
  servidoresPattern: any = /^[0-9a-zA-Z\n\r#$%?_¡ ,-ÁÉÍÓÚáéíóúñÑ]{3,100}$/;
  ciPattern: any = /^[0-9]{5,9}$/;
  phonePattern: any = /^[0-9]{6,9}$/;
  reserva:any=[{id:1,nombre:'SI'},{id:2,nombre:'NO'}];
  entidades:any=[];
  @ViewChild('f') myId: ElementRef;
  @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
  constructor(private news: NewsService) {

  }

  ngOnInit() {
    this.news.getNews().subscribe(response => {
        this.documentos = response[1];
        console.log('=>', this.documentos);
        console.log('DOCS',this.documentos);
      },
      error => {
        console.log(<any>error);
      });
    this.news.getParams().subscribe(response => {
        this.departamentos=response[0];
        this.entidades=response[1];
        console.log('DOCS',this.departamentos);
      },
      error => {
        console.log(<any>error);
      });
    this.news.getConfig().subscribe(response => {
        console.log('FILE_JSON', response);
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
  }
  onFormSubmit(data) {
    console.log(data);
    console.log(this.data);
    this.news.send(this.data).subscribe(response => {
      if ( response.code == 200) {
        notify({
          message: "El formulario fue enviado.. Gracias..",
          position: {
            my: "center top",
            at: "center top"
          }
        }, "success", 3000);
        this.myId.nativeElement.reset();
        this.captcha.reset();
      }else{
        console.log('ENTRO AQI');
        notify({
          message: "El formulario fue enviado.. Gracias..",
          position: {
            my: "center top",
            at: "center top"
          }
        }, "error", 3000);
      }
    },error => {
      console.log(error);
      notify({
        message: error.statusText,
        position: {
          my: "center top",
          at: "center top"
        }
      }, "error", 3000);
    });


    data.preventDefault();
  }
  handleCorrectCaptcha(e) {
    console.log();
    this.data.code = e;
    this.vare = false;
    /*this.news.verify(e).subscribe(response => {
        if(response.code==200){
          if(response.data.success){
            this.vaer=false;
          }else{
            this.vaer=true;
          }
        }else{
          this.vaer=true;
          notify({
            message: "Captcha error",
            position: {
              my: "center top",
              at: "center top"
            }
          }, "error", 3000);
        }
      },
      error => {
        console.log(<any>error);
      });*/

  }

}




// WEBPACK FOOTER //
// ./src/app/layouts/frm-solicitud/frm-solicitud.component.ts